import { AccountType } from '../../../redux/types'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { selectUserAccountTypeCheck } from '../../../redux/userSlice'
import { tabNames } from '../../../routers/helpers'

export const useAccountTypeCheck = (type: AccountType) => {
    const accountType = useSelector(selectUserAccountTypeCheck)
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const check = () => {
            if (accountType === undefined) {
                return
            }
            if (accountType !== type) {
                navigate('/', { replace: true })
                return
            }
            setLoading(false)
        }

        setLoading(true)
        check()
    }, [accountType, type, navigate])

    return loading
}

// Check that with the user's accountType, the user can enter this area
export const useOrgTypeCheck = (
    type: Extract<AccountType, 'school' | 'childcareCentre' | 'organisation'>
) => {
    const accountType = useSelector(selectUserAccountTypeCheck)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const check = () => {
            if (accountType === undefined) {
                return
            }
            if (
                !accountType ||
                (accountType !== 'organisation' && type !== accountType)
            ) {
                navigate(`/${tabNames.app.index}`, { replace: true })
                return
            }
            setLoading(false)
        }

        setLoading(true)
        check()
    }, [type, navigate, accountType])

    return loading
}
